import React, {useContext, useEffect} from "react";
import {RiepilogoOrePlus} from "@commons/mapping/RiepilogoOrePlus";
import {mm2HHmmFormat} from "@commons/utils/util";
import TooltipEx from "@components/Tooltip";
import {IconMoon, IconSun} from "@tabler/icons-react";
import {PresenzeContext} from "@commons/hooks/usePresenze";

interface RiepilogoOreProps {
    totali: RiepilogoOrePlus | null,
    riepilogoGiornaliero?: boolean,
    captionClassName?: string,
    showTogglePeriodo?: boolean,

    soloMeseRif?: boolean
    setSoloMeseRif?: React.Dispatch<React.SetStateAction<boolean>>,
}

const RiepilogoOre: React.FC<RiepilogoOreProps> = ({
                                                       totali, riepilogoGiornaliero = false,
                                                       captionClassName = '', showTogglePeriodo = false,
                                                       soloMeseRif: soloMeseRifAux,
                                                       setSoloMeseRif: setSoloMeseRifAux,
                                                   }) => {

    const {soloMeseRif: soloMeseRifContext, setSoloMeseRif: setSoloMeseRifContext} = useContext(PresenzeContext);
    const soloMeseRif = soloMeseRifAux === undefined ? soloMeseRifContext : soloMeseRifAux;
    const setSoloMeseRif = setSoloMeseRifAux === undefined ? setSoloMeseRifContext : setSoloMeseRifAux;

    const checkTotali = !!totali;

    const getTotali = (tipo: 'D' | 'N' | 'T') => {
        if (checkTotali) {
            const totDiurno = RiepilogoOrePlus.getTotaleDiurno(totali!);
            const totNotturno = RiepilogoOrePlus.getTotaleNotturno(totali!);

            if (tipo === 'D')
                return mm2HHmmFormat(totDiurno);
            if (tipo === 'N')
                return mm2HHmmFormat(totNotturno);
            if (tipo === 'T')
                return mm2HHmmFormat(totDiurno + totNotturno);
        } else return '???';
    }

    const totOrdNC = checkTotali ? RiepilogoOrePlus.getTotaleHOrdNC(totali!) : 0;
    const totEccNC = checkTotali ? RiepilogoOrePlus.getTotaleHEccNC(totali!) : 0;

    useEffect(() => {
        if (soloMeseRif) {
            // GestionePLUS.updateTotaliMese ??????????
        }
    }, [soloMeseRif]);

    return <>
        {totali && <table className="tableRiepiloghi fontTableRiepiloghi">
            <caption className={`tableRiepiloghiCaption fontTableRiepiloghiCaption ${captionClassName}`}>
                <span className="inline-flex items-center">
                    <span>Riepilogo ore&nbsp;&nbsp;</span>
                    <span className="text-xs">(hh/mm)</span>
                    {(checkTotali && showTogglePeriodo) && <TooltipEx tooltip="Totalizza solo il mese di riferimento" className="p-1" placement="right">
                        {/*<Toggle initialState={soloMeseRif} onChange={setSoloMeseRif} switchClassName="focus:!ring-0 focus:!ring-offset-0 ml-2"/>*/} {/* Toggle e tooltip sono due "a", quindi toggle non può essere un children */}
                        <input type="checkbox"
                               id="riepilogoOre.soloMeseRif"
                               name="riepilogoOre.soloMeseRif"
                               checked={soloMeseRif}
                               onChange={(e) => setSoloMeseRif(e.target.checked)}
                               className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 ml-2"/>
                    </TooltipEx>}
                    {/*&nbsp;&nbsp;&nbsp;&nbsp;
                    {(checkTotali && showTogglePeriodo) && <label htmlFor="gestione.soloMeseRif">
                            <input type="checkbox" id="gestione.soloMeseRif" name="gestione.soloMeseRif"
                                   defaultChecked={soloMeseRif}
                                   className="h-3 w-3 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                   onClick={() => {
                                       if (setSoloMeseRif)
                                           setSoloMeseRif(!soloMeseRif);
                                   }}/>
                            <span className="text-[11px]">&nbsp;Totalizza solo il mese di riferimento</span></label>}*/}
                </span>
            </caption>
            <thead>
            <tr className="tableRiepiloghiBorderB">
                <th className="tableRiepiloghiBorderR w-1/4"></th>
                <th className="w-1/4">
                    <span className="inline-flex">
                        <IconSun size={13}/>&nbsp;Diurno
                    </span>
                </th>
                <th className="w-1/4">
                    <span className="inline-flex">
                        <IconMoon size={13}/>&nbsp;Notturno
                    </span>
                </th>
                <th className="w-1/4">
                    Totale
                </th>
            </tr>
            </thead>

            <tbody>
            <tr className="text-center">
                <td className="tableRiepiloghiLabelTD">Previste</td>
                <td>{mm2HHmmFormat(totali.hPrevDiurne)}</td>
                <td>{mm2HHmmFormat(totali.hPrevNotturne)}</td>
                <td>{mm2HHmmFormat(RiepilogoOrePlus.getTotaleHPrev(totali))}</td>
            </tr>
            <tr className="text-center">
                <td className="tableRiepiloghiLabelTD">Ordinarie</td>
                <td>{mm2HHmmFormat(totali.hOrdDiurne)}</td>
                <td>{mm2HHmmFormat(totali.hOrdNotturne)}</td>
                <td>{mm2HHmmFormat(RiepilogoOrePlus.getTotaleHOrd(totali))}</td>
            </tr>
            <tr className="text-center">
                <td className="tableRiepiloghiLabelTD">Eccedenti</td>
                <td>{mm2HHmmFormat(totali.hEccDiurne)}</td>
                <td>{mm2HHmmFormat(totali.hEccNotturne)}</td>
                <td>{mm2HHmmFormat(RiepilogoOrePlus.getTotaleHEcc(totali))}</td>
            </tr>
            <tr className="text-center">
                <td className="tableRiepiloghiLabelTD border-b border-[#218a9e]">Totali</td>
                <td className="border-b border-[#218a9e]">{getTotali('D')}</td>
                <td className="border-b border-[#218a9e]">{getTotali('N')}</td>
                <td className="border-b border-[#218a9e]">{getTotali('T')}</td>
            </tr>

            {riepilogoGiornaliero && (totOrdNC > 0) && <>
                <tr className="text-orange-500 text-center">
                    <td className="tableRiepiloghiLabelTD">
                        <TooltipEx tooltip="Ordinarie non computabili perchè inferiori al limite indicato.">
                            Ord. NC
                        </TooltipEx>
                    </td>
                    <td>{mm2HHmmFormat(totali.hOrdDiurneNC)}</td>
                    <td>{mm2HHmmFormat(totali.hOrdNotturneNC)}</td>
                    <td>{mm2HHmmFormat(totOrdNC)}</td>
                </tr>
            </>}

            {riepilogoGiornaliero && (totEccNC > 0) && <>
                <tr className="text-orange-500 text-center">
                    <td className="tableRiepiloghiLabelTD">
                        <TooltipEx tooltip="Eccedenti non computabili perchè inferiori al limite indicato.">
                            Ecc. NC
                        </TooltipEx>
                    </td>
                    <td>{mm2HHmmFormat(totali.hEccDiurneNC)}</td>
                    <td>{mm2HHmmFormat(totali.hEccNotturneNC)}</td>
                    <td>{mm2HHmmFormat(totEccNC)}</td>
                </tr>
            </>}

            <tr className="text-center">
                <td className="tableRiepiloghiLabelTD">
                    <TooltipEx tooltip="Durata pausa flessibile">Pausa</TooltipEx>
                </td>
                <td>{mm2HHmmFormat(totali.hPausaDiurne)}</td>
                <td>{mm2HHmmFormat(totali.hPausaNotturne)}</td>
                <td>{mm2HHmmFormat(totali.hPausaDiurne + totali.hPausaNotturne)}</td>
            </tr>

            <tr className={`${totali.hMancanti > 0 && 'text-red-600 font-semibold'} text-center`}>
                <td className="tableRiepiloghiLabelTD">Mancanti</td>
                <td></td>
                <td></td>
                <td>{mm2HHmmFormat(totali.hMancanti)}</td>
            </tr>

            <tr className="text-center">
                <td className="tableRiepiloghiLabelTD">Ritardo</td>
                <td></td>
                <td></td>
                <td>{mm2HHmmFormat(RiepilogoOrePlus.getTotaleRitardo(totali))}</td>
            </tr>
            </tbody>

            {/*{(checkTotali && showTogglePeriodo) && <caption className={`caption-bottom whitespace-nowrap mt-1 fontTableRiepiloghiCaption ${captionClassName}`}>
                <input type="checkbox" id="gestione.soloMeseRif" name="gestione.soloMeseRif"
                       defaultChecked={soloMeseRif}
                       className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                       onClick={() => {
                           if (setSoloMeseRif)
                               setSoloMeseRif(!soloMeseRif);
                       }}/>
                <label htmlFor="gestione.soloMeseRif" className="text-[11px]">&nbsp;Totalizza solo il mese di riferimento</label>
            </caption>}*/}
        </table>}
    </>
}

export default RiepilogoOre;
//export default memo(RiepilogoOre);
